import React, { FC, ReactElement } from 'react';

import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';
import { TextField } from '@mui/material';
import ConnectForm from '../../../../common/reactHookForm/ConnectForm';
import AxiomaW1NBIoTConfigModel from '@thingslog/repositories/src/initialConfig/AxiomaW1NBIOTConfigModel';
import NbIoTNetworkConfigurationFields from './NbIoTNetworkConfigurationFields';

const AxiomaW1NBIOTNetworkConfiguration: FC<AxiomaW1NBIOTNetworkConfigurationProps> = () => {
  const { t } = useTranslation();

  return (
    <ConnectForm<AxiomaW1NBIoTConfigModel>>
      {({ register, control }: UseFormReturn<AxiomaW1NBIoTConfigModel>): ReactElement => (
        <div className="grid grid-cols-4 max-xl:grid-cols-3 max-lg:grid-cols-2 gap-5">
          <NbIoTNetworkConfigurationFields />
          <TextField
            {...register('findEncryptionKeyByDeviceNumber')}
            label={t('device_initial_config_find_encryption_key_by_device_number')}
            size="small"
          />
        </div>
      )}
    </ConnectForm>
  );
};

interface AxiomaW1NBIOTNetworkConfigurationProps {}

export default AxiomaW1NBIOTNetworkConfiguration;
